<template>
  <div>
      <div class="inner-header">
          <nav class="navbar fixed-top animate__animated animate__slideInRight">
              <a @click="$router.go(-1)" class="back-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
                      <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                          <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none"
                              stroke="#000" stroke-width="2" />
                          <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15"
                              transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2" />
                      </g>
                  </svg>
              </a>
              <a href="javascript:void(0);" class="link-title">Attachments</a>
          </nav>
      </div>
      <div class="inner-page animate__animated animate__slideInRight">
          <div class="container-fluid">
              <div class="row">
                  <!-- Enquiry Card -->
                  <div class="col-12">
                      <div class="card details-card">
                        <div class="card-body">
                              <div class="row" v-if="image_details">
                                  <div class="col-12" v-for="(url, key) in image_details" :key="key">
                                      <span class="enq-title m-0">{{url.title}}</span>
                                      <div class="overlay-image">
                                          <img :src="url.image_url" alt="" class="img-fluid gallery-pic"/>
                                          <a :href="url.image_url" target="_blank" :download="url.image_url" class="btn-view"><img src="@/assets/download-icon-white.svg" class="mr-1"/>Download</a>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
               
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'Impression',
  data() {
    return {
      queryP: {},
      ProjectDetails: {},
      Projectid: '',
      image_details: []
    }
  },
  created () {
    this.FetchProjectDetails()
  },
  methods: {
    FetchProjectDetails() {
    this.queryP['id'] = this.$route.params.id;
    this.queryP['building_broker_id'] = this.$route.params.building_broker_id;
    this.$axios.get(`buildings/show_buildings`, { params: this.queryP }).then((res) => {
        this.ProjectDetails = JSON.parse(JSON.stringify(res.data).substring(1, JSON.stringify(res.data).length-1));
        this.image_details = this.ProjectDetails.project_informations.image_url
      });
    }
  }
}
</script>
<style scoped>
  .inner-page {
      margin-top: 60px;
  }
  .cursor-pointer {
      cursor: pointer;
  }
  .overlay-image {
      position: relative;
      margin: 10px 0;
  }
  .overlay-image::after{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 6px;
      
  }
  .overlay-image .gallery-pic{
      object-fit: cover;
      width: 100%;
      max-height: 250px;
      object-position: center;
      border-radius: 6px;
  }
  .btn-view{
      background: rgba(0, 0, 0, 0.4);
      
     
      border-radius: 34px;
      font-weight: 500;
      font-size: 12px;
      text-align: center;
      letter-spacing: 0.1px;
      color: #FFFFFF;
      text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.4);
      position: absolute;
      right: 0%;
      top: 0;
      padding: 5px 10px;
      z-index: 9;
      margin: 10px;
  }
</style>